import axios from "axios"
import { URL_BASE } from '../../../config/config'

const RESOURCE = 'userrequests'


export default {
    state: {
        items: {
            data: []
        },

        store: false
    },

    mutations: {
        LOAD_USER_REQUESTS (state, data) {
            state.items = data
        },
    },

    actions: {
        async loadUserRequests({ commit }, params) {
            try {
                commit('PRELOADER', true); // Inicia o estado de carregamento
                const response = await axios.get(`${URL_BASE}${RESOURCE}`, { params }); // Faz a requisição
                commit('LOAD_USER_REQUESTS', response.data); // Atualiza o estado Vuex com os dados da API
            } catch (error) {
                if (error.response && error.response.status === 401) {
                    window.location.href = "login"; // Redireciona para login se não autorizado
                } else {
                    console.error('Erro ao carregar propriedades:', error);
                }
            } finally {
                commit('PRELOADER', false); // Finaliza o estado de carregamento
            }
        },

        // No seu arquivo do Vuex (ex: modules/user-requests/store.js)
        async fetchUserRequests({ commit }, params) {
            try {
                commit('PRELOADER', true);
                const response = await axios.get(`${URL_BASE}${RESOURCE}`, { params });
                
                // Retornamos os dados diretamente para quem chamou a action
                return response.data; 
                
            } catch (error) {
                if (error.response && error.response.status === 401) {
                    window.location.href = "login";
                } else {
                    console.error('Erro ao carregar solicitações:', error);
                    throw error; // Lançamos o erro para o componente poder tratar se quiser
                }
            } finally {
                commit('PRELOADER', false);
            }
        },

        async showUserRequest({ commit }, id) {
            try {
                commit('PRELOADER', true);
                const response = await axios.get(`${URL_BASE}${RESOURCE}/${id}`);
                return response.data;
            } catch (error) {
                if (error.response && error.response.status === 401) {
                    window.location.href = "login";
                } else {
                    console.error('Erro ao carregar propriedade:', error);
                }
            } finally {
                commit('PRELOADER', false);
            }
        },


        /* 
        loadUserRequests(context, params) {
            context.commit('PRELOADER', true)
            axios.get(`${URL_BASE}${RESOURCE}`, {params})
                .then( response =>
                        {
                            context.commit('LOAD_USER_REQUESTS', response.data)
                        }
                )
                //.catch( errors => console.log(errors))
                .catch((error) => {
                    if(error.response && error.response.status === 401) {
                        window.location.href = "login";
                    }

                })
                .finally(() => context.commit('PRELOADER', false))
        },
        */

        loadPromisseUserRequest(context, params) {
            context.commit('PRELOADER', true)
            return new Promise((resolve, reject) => {
                axios.get(`${URL_BASE}${RESOURCE}`, {params})
                    .then(response => resolve(response.data))
                    .catch(function(error) {
                        if (error.response && error.response.status === 401) {
                          window.location.href = "login";
                        }
                        reject(error)
                    })
                    .finally(() => context.commit('PRELOADER', false))
            })
        },

        storeUserRequest (context, params) {
            context.commit('PRELOADER', true)
            return new Promise((resolve) => {
                axios.post(`${URL_BASE}${RESOURCE}`, params)
                    .then(response => resolve(response.data))
                    .catch(error => console.log(error))
                    .finally(() => context.commit('PRELOADER', false))
            })
        },
        
        updateUserRequest(context, params){
            context.commit('PRELOADER', true)
            return new Promise((resolve, reject) => {
                axios.put(`${URL_BASE}${RESOURCE}/${params.id}`, params)
                    .then(response => resolve(response.data))
                    .catch(function(error) {
                        if (error.response && error.response.status === 401) {
                          window.location.href = "login";
                        }
                        reject(error)
                    })
                    .finally(() => context.commit('PRELOADER', false))
            })
        },

        loadUserRequest(context, id) {
            context.commit('PRELOADER', true)
            return new Promise((resolve, reject) => {
                axios.get(`${URL_BASE}${RESOURCE}/${id}`)
                    .then(response => resolve(response.data))
                    .catch(function(error) {
                        if (error.response && error.response.status === 401) {
                          window.location.href = "login";
                        }
                        reject(error)
                    })
                    .finally(() => context.commit('PRELOADER', false))
            })
        },

        destroyUserRequest(context, id){
            context.commit('PRELOADER', true)
            return new Promise((resolve, reject) => {
                axios.delete(`${URL_BASE}${RESOURCE}/${id}`)
                    .then(response => resolve(response.data))
                    .catch(error => reject(error))
                    .finally(() => context.commit('PRELOADER', false))    
            })
            
        },

    },

    getters: {

    }

}